// extracted by mini-css-extract-plugin
export default {"root":"StartPage_root-MlI","bookTitle":"StartPage_bookTitle-bDM","bookSubtitle":"StartPage_bookSubtitle-stF","bookList":"StartPage_bookList-Cmq"};